import React from "react";
import { useStore } from "@/context/StoreContext";

export const WhatsAppFloat = () => {
  const { config } = useStore();
  const number = config.whatsapp_number || "919999999999";
  const href = `https://wa.me/${number}?text=${encodeURIComponent("Hello SCHOKODALE, I would love to know more about your chocolates.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-2xl hover:scale-110 transition-transform animate-float"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff">
        <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.609 6.004L4 29l8.164-1.57a11.93 11.93 0 0 0 3.84.629h.004C22.621 28.059 28 22.676 28 16.055 28 8.383 22.621 3 16.004 3zm0 21.883h-.004a9.86 9.86 0 0 1-3.422-.605l-.246-.098-4.844.93.945-4.719-.16-.25a9.84 9.84 0 0 1-1.52-5.234c0-5.465 4.449-9.914 9.918-9.914 2.648 0 5.137 1.031 7.012 2.902a9.83 9.83 0 0 1 2.902 7.016c0 5.465-4.449 9.914-9.914 9.914zm5.445-7.422c-.297-.148-1.758-.867-2.031-.965-.273-.098-.473-.148-.672.15-.199.297-.77.964-.945 1.162-.172.199-.348.223-.645.075-.297-.149-1.254-.462-2.39-1.475-.883-.788-1.48-1.761-1.652-2.059-.172-.297-.019-.457.13-.605.134-.133.297-.348.445-.521.149-.174.199-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.672-1.62-.922-2.219-.242-.58-.488-.502-.672-.512l-.573-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.693.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.007-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      </svg>
    </a>
  );
};
